import { Container, Grid, Toolbar, Typography, useMediaQuery } from '@mui/material';

import BackLink from "../../Components/BackLink.js";
import CategoryListLinkBlock from "../../Components/Block/CategoryListLinkBlock.js";
import makeStyles from '@mui/styles/makeStyles';
import theme from "../../theme.js";
import { generatePathCategory } from "../../Utils/Routes.js";
import Header from '../../Layouts/Header.js';
import CategoryListSearchBox from '../../Components/Filters/CategoryListSearchBox.js';
import { useMemo, useState } from 'react';
import Page from '../../Components/Page.js';
import AwardListMenu from "../../Components/AwardListMenu.js";
import { useMyListEntries } from '../../Utils/Entry';
import { useAwards } from '../../Utils/Award.js';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useScrollToTop } from '../../Utils/ScrollToTop.js';

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor: '#121212', //theme.palette.primary.main,
        color: theme.palette.secondary.light,
    },
    subHeaderGridWrap: {
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
        },
    },
    gridWrap: {
        padding: theme.spacing(0),
        paddingTop: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingTop: theme.spacing(8),
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
        },
    },
    titleContainer: {

    },
    title: {
        textTransform: "uppercase",
        //fontSize: "1.2rem",
    }
}));

export default function AwardCategoryListPage({ backUrl, ...props }) {
    const classes = useStyles();
    const { awardId } = useParams();
    const awards = useAwards();
    const award = useMemo(() => awards?.find(award => award && awardId && ""+award.awardId === ""+awardId ), [awards, awardId]);
    const myListEntries = useMyListEntries(awards);

    const isEntrySearch = award?.judgingMediaType?.toLocaleLowerCase() === "video";

    const location = useLocation();
    const { q: initialSearchQuery } = getQueryParams(location.search);

    const [searchQuery, setSearchQuery] = useState(initialSearchQuery);

    useScrollToTop();

    const isMdUp = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const isTabletPro = useMediaQuery(theme.breakpoints.down('lg'), {
        defaultMatches: true
    });
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
        defaultMatches: true
    });

    const rawCategories = award?.categories ? Object.values(award.categories) : [];
    const categories = rawCategories
        .filter(category => category.numEntries > 0)
        ;

    const displayCategories = categories
        // filter by search bar text
        .filter(category => !searchQuery || !searchQuery.trim() || category.title.toLowerCase().indexOf(searchQuery.trim().toLowerCase()) !== -1)
        // sort from A-Z
        .sort((a, b) => a.title.localeCompare(b.title))
        ;

    const navigate = useNavigate();
    function setSearchURL(searchQuery) {
        navigate(searchQuery ? `?q=${searchQuery}` : ".")
    }

    function onSubmit(query) {
        //if(query && query.trim() && query !== initialSearchQuery)
        if(isEntrySearch) {
            if(!query.trim()) return;
            navigate(generatePathCategory(awardId, "all") + `?searchQuery=${query}`);
        }
        else {
            setSearchQuery(query);
            setSearchURL(query);
        }
    }

    const categorySearch = (
        <CategoryListSearchBox 
            searchQuery={searchQuery} 
            onSubmit={onSubmit} 
            placeholderText={isEntrySearch ? "Search Titles..." : "Search Categories..."} 
        />
    );

    return (
        <Page title={award?.title}>
            {award &&
                <>
                    <Header style={{ paddingBottom: "1rem" }} />
                    <Toolbar disableGutters={true} className={classes.header} style={{ alignItems: "stretch" }}>
                        <Container maxWidth="xl">
                            <Grid container className={classes.subHeaderGridWrap} style={{ height: "100%" }} direction="row" justifyContent="space-between" alignItems="flex-end">
                                {!isMobile ? (
                                    <Grid item xs={false} style={{ flexShrink: 1, flexGrow: 0 }} >
                                        <BackLink to={backUrl} />
                                    </Grid>
                                ) : ""}
                                <Grid item xs={true} style={{ alignSelf: "stretch", color: "white", display: "flex", alignItems: "center", }} className={classes.titleContainer}>
                                    <AwardListMenu currentAward={award} currentFixedCategories={[{ title: award?.title }]} showMyList={myListEntries?.length > 0} />
                                </Grid>
                                {!isMobile ? (
                                    <Grid item xs={2} md={3} lg={3} style={{ alignSelf: "flex-end" }}>
                                        {isMdUp && categorySearch}
                                    </Grid>
                                ) : ""}
                            </Grid>
                        </Container>
                    </Toolbar>
                    <Container maxWidth="xl">
                        {!isMdUp && categorySearch}
                        <div className={classes.gridWrap}>
                            <Grid container style={props.styles} spacing={isMobile ? 2 : 8}>
                                {categories.length ? (
                                    displayCategories.length ? displayCategories.map(category => (
                                        <Grid key={category.id} item xs={12} sm={6} md={isTabletPro ? 6 : 4} lg={4} xl={3}>
                                            <CategoryListLinkBlock
                                                to={generatePathCategory(awardId, category.id)}
                                                label={category.title}
                                                number={formatCount(category.numEntries)}
                                                style={{ height: "100%" }} />
                                        </Grid>
                                    )) : (
                                        <Grid item >
                                            <Typography variant="h6">There are no categories matching your search.</Typography>
                                        </Grid>
                                    )
                                ) : (
                                    <Grid item >
                                        <Typography variant="h6">There are no Categories to view currently. Please look out for emails from membership which will alert you to when Viewing and Voting rounds for the Awards are open.</Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                    </Container>
                </>
            }
        </Page>
    );
}

function formatCount(number) {
    if (number >= 10) {
        return "" + number;
    }
    return "0" + Math.max(number, 0);
}

function getQueryParams(queryString) {
    const params = new URLSearchParams(queryString);

    // Warning: this does NOT support array params e.g. ?foo[]=1&foo[]=2
    return Object.fromEntries(params.entries());
}